import React, { useState } from "react";

const questions = [
  {
    title: (
      <>
        <span className="font-bold">
        Obtain and review documents </span> relating
to property owned, leased by the
company
      </>
    ),
    comment: "Put comments here",
  },
  {
    title: (
      <>
        <span className="font-bold">
        Are there any material liens,
 restrictions, violations, covenants, </span>
servitudes and agreements of any significance affecting any property
owned or leased by the company? 
      </>
    ),
    comment: "Put comments here",
  },
  {
    title: (
      <>
        <span className="font-bold">
        Copies of all mortgages over the
        properties
        </span>{" "}
      
      </>
    ),
    comment: "Put comments here",
  },
  {
    title: (
      <>
        <span className="font-bold">
        Establish duration of lease 
        </span>{" "}
        and any
        possible causes for termination
      </>
    ),
    comment: "Put comments here",
  },
  {
    title: (
      <>
        <span className="font-bold">
        Determine if there are any disputes in
        relation to the property or lease
        </span>{" "}
      
      </>
    ),
    comment: "Put comments here",
  },
];

const OptionButton = ({ label, selected, onClick }) => (
  <div className="flex flex-col items-center space-y-2 md:space-y-5">
    <span className="text-[8px] md:text-[24px] font-medium">{label}</span>
    <button
      onClick={onClick}
      className={`w-[20px] h-[20px] md:w-[53px] md:h-[53px] rounded-full transition
        ${selected ? 'bg-[#03897B] border-[3px] md:border-[8px] border-white' : 'bg-transparent border-[6px] md:border-[8px] border-white'}
      `}
    ></button>
  </div>
);

export default function RealProperty() {
  const [responses, setResponses] = useState({});

  const handleSelect = (index, value) => {
    setResponses({ ...responses, [index]: value });
  };

  return (
    <div className="space-y-4 md:-mt-10">
      <div className="h-2 md:h-8" />

      <div>
      <div className="flex justify-end md:mt-2 mt-2">
        <button
          className="flex items-center md:gap-2 gap-2  hover:bg-[#0f1f1a] text-black hover:text-white  md:py-3 py-1 rounded-md text-[6px] md:text-lg font-normal italic transition"
        >
          Save
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745670022/Arhive_load_duotone_line_c6pcpp.png"
            alt="Save Icon"
            className="md:w-11 md:h-11 h-3 w-3"
          />
        </button>
      </div>
        <h2 className="text-[8px] md:text-[24px] font-bold  text-[#03897B] ">
          <span className="text-[#979797]">Section 5 : </span>  REAL PROPERTY (LAND & BUILDINGS)
        </h2>
  
      </div>


  

      {questions.map((q, i) => (
        <div
          key={i}
          className="flex space-x-2 h-[100px] md:h-[233px] md:min-w-[700px]"
        >
          <div className="w-[100px] md:w-[390px] bg-[#E7EBEB] rounded-[5px] p-3 md:p-4 text-[6px] md:text-[24px] inline leading-[1.2]">
            {q.title}
          </div>

          {["Y", "N", "NA"].map((opt) => (
            <div
              key={opt}
              className="w-[40px] md:w-[100px] bg-[#E7EBEB] rounded-[5px] flex justify-center items-center md:pb-16"
            >
              <OptionButton
                label={opt}
                selected={responses[i] === opt}
                onClick={() => handleSelect(i, opt)}
              />
            </div>
          ))}

          <div className="w-[100px] md:w-[500px] bg-[#E7EBEB] rounded-[5px] p-3 md:p-4 text-[6px] md:text-[24px] flex">
            {q.comment}
          </div>
        </div>
      ))}
    </div>
  );
}
